import { render, staticRenderFns } from "./AcceptTerms.vue?vue&type=template&id=63082e1a"
import script from "./AcceptTerms.vue?vue&type=script&lang=js"
export * from "./AcceptTerms.vue?vue&type=script&lang=js"
import style0 from "./AcceptTerms.vue?vue&type=style&index=0&id=63082e1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports